import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchWorkCycleAvailableCourseById } from 'app/actions/CourseActions';
import { getCourseWorkCycleAvailable } from 'app/reducers';
import isEmpty from 'app/utils/IsEmpty';

export default function CourseWorkCycleAvailableContainer(props){

    let courseWorkCycleAvailable = useSelector(getCourseWorkCycleAvailable);
    const dispatch = useDispatch();
    
    useEffect(() => {
        if (isEmpty(courseWorkCycleAvailable)) fetchCourseWorkCycleAvailableAction();
    }, []);

    const fetchCourseWorkCycleAvailableAction = () => dispatch(fetchWorkCycleAvailableCourseById(props.id));
    courseWorkCycleAvailable.map(item => item['key'] = item.idTest);
    courseWorkCycleAvailable.map(item => item['disabled'] = false);
    return (props.children({ courseWorkCycleAvailable}));
}